/** Formulário de distribuição de pastas */
import React, { Component } from "react";
import { Row, Button, Col, Modal } from "antd";

import Pipeuser from "../Pipeuser";

import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";

export default class Form extends Component {
  state = {
    loading: true,
    importando: false, // Importando loading
    error: null,
    pastas: 0, // Pastas disponíveis para importar
    distribuido: 0,
    pastas_operator: {} // Pastas por operador
  };

  async componentDidMount() {
    /** Obtém a quantidade de pastas disponíveis para importar */

    this.setState({
      loading: true
    });

    await api
      .get("/importacao/", {
        params: {
          departamento: this.props.departamento_id
        }
      })
      .then(response => {
        this.setState({
          pastas: response.data.pastas,
          distribuido: response.data.pastas
        });
      })
      .catch(() => {
        this.setState({
          error: "Falha ao obter a quantidade de pastas disponíveis."
        });
      });

    this.setState({
      loading: false
    });
  }

  /**
   * @param event - Evento onChange
   * @param operador_id - Id do operador no pipedrive
   * @param changeAmount (Function) - Altera a quantidade do campo
   */
  handleAmountChange = (event, operador_id, changeAmount) => {
    /** Função chamada quando a quantidade por usuário é alterada */
    const value = parseInt(event.target.value);
    const total = this.state.pastas;

    if (parseInt(value) < 0 || isNaN(value)) {
      changeAmount(0);

      let pastas_operator = this.state.pastas_operator;
      pastas_operator[operador_id] = 0;

      this.setState({
        pastas_operator
      });

      return;
    }

    let soma = 0;

    const inputs = document.querySelectorAll(".imp__amount");

    Array.from(inputs).map(input => {
      let inpvalue = input.value;

      if (
        parseInt(inpvalue) < 0 ||
        parseInt(inpvalue) == NaN ||
        inpvalue == null ||
        inpvalue == ""
      ) {
        soma += 0;
      } else {
        soma += parseInt(inpvalue);
      }
    });

    if (soma > total) {
      changeAmount(0);

      let pastas_operator = this.state.pastas_operator;
      pastas_operator[operador_id] = 0;

      this.setState({
        pastas_operator,
        distribuido: parseInt(this.state.pastas) - (soma - parseInt(value))
      });

      Modal.error({
        title: "Erro",
        content:
          "A soma da distribuição não pode ultrapassar a quantidade de pastas"
      });
      return;
    }

    this.setState({
      distribuido: parseInt(this.state.pastas) - soma
    });

    changeAmount(value);

    let pastas_operator = this.state.pastas_operator;
    pastas_operator[operador_id] = parseInt(value);

    this.setState({
      pastas_operator
    });
  };

  /** Executa a importação */
  handleImportacao = async () => {
    if (this.state.pastas <= 0) {
      Modal.error({
        title: "Erro",
        content: "Não há pastas para serem importadas!"
      });
      return;
    }

    /** Verifica se as quantidades foram informadas */
    const inputs = document.querySelectorAll(".imp__amount");
    let soma = 0;

    Array.from(inputs).map(input => {
      let inpvalue = input.value;

      if (
        parseInt(inpvalue) > 0 &&
        parseInt(inpvalue) != NaN &&
        inpvalue != null &&
        inpvalue != ""
      ) {
        soma += parseInt(inpvalue);
      }
    });

    if (soma < 1) {
      Modal.error({
        title: "Erro",
        content: "Informe a quantidade de pastas por usuário!"
      });
      return;
    }

    this.setState({
      importando: true
    });

    await api
      .post("/importacao/", {
        departamento: this.props.departamento_id,
        total_pastas: soma,
        ...this.state.pastas_operator
      })
      .then(response => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          ),
          onOk: () => window.location.reload(),
          onCancel: () => window.location.reload()
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      importando: false
    });
  };

  render() {
    return (
      <div className="imp_form__container">
        <div className="imp_form__infos">
          <div className="imp_form_info">
            {this.state.loading ? (
              "..."
            ) : this.state.error ? (
              this.state.error
            ) : (
              <div className="imp_form_info">
                Pastas disponíveis para importação:{" "}
                <b>{this.state.distribuido}</b>
              </div>
            )}
            <div className="imp_form_info">
              Defina a quantidade de pastas para cada usuário para realizar a
              importação.
            </div>
          </div>
        </div>
        <div className="imp_form__users">
          <Row gutter={8}>
            {this.props.users.map(user => (
              <Col md={{ span: 5 }} key={user.id}>
                <Pipeuser
                  username={user.usuario.user.username}
                  pipedrive_id={user.usuario.id_pipedrive}
                  pipedrive_token={this.props.pipedrive_token}
                  function_change={this.handleAmountChange}
                />
              </Col>
            ))}
          </Row>
        </div>
        <div className="imp_form__footer">
          <Button
            type="primary"
            onClick={this.handleImportacao}
            loading={this.state.importando}
          >
            Importar
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Importacao/Form/index.js